export default __webpack_public_path__ + "static/media/email.61fb0b08.svg";